exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.contact-menu.dropdown-menu > li {\n\tfont-size: 14px;\n}\n", ""]);

// exports
